import {useMemo} from "react";
import {getQueries} from "../utils/SchoolBlocksUtilities";
import {GridTypes} from "../utils/SchoolBlocksUtilities";
import {useStores} from "../stores/useStores";

export const useGridType = (options: {useTitleOrg?: boolean} = {}): "terraced" | "packery" => {
    const {interfaceStore, organizationStore} = useStores();
    const {useTitleOrg = false} = options;

    const organization = useTitleOrg ? organizationStore.organization : organizationStore.currentOrganization;

    return useMemo(() => {
        const queries = getQueries(interfaceStore.currentFullUrl || "");
        if (queries.gridType && GridTypes[queries.gridType] &&
            (useTitleOrg ? organizationStore.organization.id === organizationStore.currentOrganization.id : true)) {
            return GridTypes[queries.gridType]
        }
        return !!organization.json_data?.terracedGrid?.enabled ? GridTypes.terraced : GridTypes.packery;
    }, [interfaceStore.currentFullUrl, organization?.json_data?.terracedGrid?.enabled])
}